export const HYDRATE_PRODUCTS = 'posData/HYDRATE_PRODUCTS';
export const HYDRATE_SERVICES = 'posData/HYDRATE_SERVICES';
export const HYDRATE_PRINT_MATERIALS = 'posData/HYDRATE_PRINT_MATERIALS';
export const HYDRATE_CUSTOMERS = 'posData/HYDRATE_CUSTOMERS';
export const HYDRATE_VENDORS = 'posData/HYDRATE_VENDORS';
export const HYDRATE_PURCHASES = 'posData/HYDRATE_PURCHASES';
export const HYDRATE_PAYMENT_METHODS = 'posData/HYDRATE_PAYMENT_METHODS';
export const HYDRATE_SALES = 'posData/HYDRATE_SALES';
export const HYDRATE_CREDITS = 'posData/HYDRATE_CREDITS';
export const HYDRATE_DUE_COLLECTIONS = 'posData/HYDRATE_DUE_COLLECTIONS';
export const HYDRATE_EXPENSES = 'posData/HYDRATE_EXPENSES';
export const SAVE_PRODUCT = 'posData/SAVE_PRODUCT';
export const SAVE_SERVICE = 'posData/SAVE_SERVICE';
export const SAVE_PRINT_MATERIAL = 'posData/SAVE_PRINT_MATERIAL';
export const REMOVE_PRINT_MATERIAL = 'posData/REMOVE_PRINT_MATERIAL';
export const SAVE_CUSTOMER = 'posData/SAVE_CUSTOMER';
export const SAVE_VENDOR = 'posData/SAVE_VENDOR';
export const SAVE_STOCK = 'posData/SAVE_STOCK';
export const CANCEL_SALE = 'posData/CANCEL_SALE';
export const SETTLE_CREDIT = 'posData/SETTLE_CREDIT';
export const ADD_PAYMENT_METHOD = 'posData/ADD_PAYMENT_METHOD';
export const REMOVE_PAYMENT_METHOD = 'posData/REMOVE_PAYMENT_METHOD';
export const COMPLETE_SALE = 'posData/COMPLETE_SALE';
export const RECORD_PURCHASE = 'posData/RECORD_PURCHASE';
export const PAY_PURCHASE = 'posData/PAY_PURCHASE';
export const CANCEL_PURCHASE = 'posData/CANCEL_PURCHASE';
export const SET_DATE_FORMAT = 'posData/SET_DATE_FORMAT';
export const INITIALIZE_SEED = 'posData/INITIALIZE_SEED';
